module.exports = __webpack_public_path__ + "static/media/nu.971e5c2f.svg";